import { useState } from "react";
import request from "../request";

const useAuth = () => {
  const [admin_email, set_admin_email] = useState("");
  const [admin_password, set_admin_password] = useState("");
  const login = async () => {
    if (!admin_email || !admin_password) {
      alert("Invalid login credentials");
    } else {
      try {
        const res = await request.post("/auth/admin", {
          email: admin_email,
          password: admin_password,
        });
        // alert(res.data);
        window.localStorage.setItem("admin", JSON.stringify(res.data));
        window.location.reload();
      } catch (err) {
        alert(err.response.data);
      }
    }
  };
  const logout = () => {
    window.localStorage.clear();
    window.location.reload();
  };
  return { login, set_admin_email, set_admin_password, logout };
};

export default useAuth;
